import styled from '@emotion/native';
import { Text, View, ScrollView } from 'react-native';
import { green, white, lightGreen } from '@/shared/styles/colors';
import { H1, BodyText } from '@/shared/components/StyledText';

// Dark mode (original) components
export const ContentContainer = styled(ScrollView)<{ isDesktop: boolean }>(
  ({ isDesktop }) => ({
    flex: 1,
    width: '100%',
    backgroundColor: green,
    paddingHorizontal: isDesktop ? 56 : 16,
    paddingVertical: isDesktop ? 32 : 16,
  }),
);

export const SectionTitle = styled(H1)({
  marginBottom: 12,
  color: white,
});

export const Copy = styled(BodyText)<{
  bold?: boolean;
  marginBottom?: number;
  italic?: boolean;
}>(({ bold, marginBottom, italic }) => ({
  color: white,
  fontSize: 14,
  ...(bold && { fontWeight: 'bold' }),
  ...(marginBottom && { marginBottom }),
  ...(italic && { fontStyle: 'italic' as const }),
}));

export const List = styled.View({
  paddingLeft: 16,
});

export const BulletPoint = styled(View)({
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginBottom: 8,
});

export const BulletSymbol = styled(Text)({
  fontSize: 14,
  marginRight: 6,
  lineHeight: 20,
  color: white,
});

export const BulletText = styled(Copy)({
  flex: 1,
  color: white,
});

/** Column beside a main bullet (•) when content includes nested lists (Views are not valid inside Text). */
export const BulletColumn = styled(View)({
  flex: 1,
  flexDirection: 'column',
});

/** Indented list under a main bullet (nested ◦ / ○ items). */
export const NestedList = styled.View({
  paddingLeft: 8,
  marginTop: 4,
  width: '100%',
});

export const Divider = styled.View({
  height: 1,
  backgroundColor: white,
  opacity: 0.2,
  marginVertical: 24,
});

export const Link = styled(Copy)({
  textDecorationLine: 'underline',
  cursor: 'pointer',
});

// Light mode components
export const ContentContainerLight = styled(ScrollView)<{ isDesktop: boolean }>(
  ({ isDesktop }) => ({
    flex: 1,
    width: '100%',
    backgroundColor: white,
    paddingHorizontal: isDesktop ? 56 : 16,
    paddingVertical: isDesktop ? 32 : 16,
  }),
);

export const SectionTitleLight = styled(H1)({
  marginBottom: 12,
  color: lightGreen,
});

export const CopyLight = styled(BodyText)<{
  bold?: boolean;
  marginBottom?: number;
  italic?: boolean;
}>(({ bold, marginBottom, italic }) => ({
  color: lightGreen,
  fontSize: 14,
  ...(bold && { fontWeight: 'bold' }),
  ...(marginBottom && { marginBottom }),
  ...(italic && { fontStyle: 'italic' as const }),
}));

export const ListLight = styled.View({
  paddingLeft: 16,
});

export const BulletPointLight = styled(View)({
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginBottom: 8,
});

export const BulletSymbolLight = styled(Text)({
  fontSize: 14,
  marginRight: 6,
  lineHeight: 20,
  color: lightGreen,
});

export const BulletTextLight = styled(CopyLight)({
  flex: 1,
  color: lightGreen,
});

export const DividerLight = styled.View({
  height: 1,
  backgroundColor: lightGreen,
  opacity: 0.2,
  marginVertical: 24,
});

export const LinkLight = styled(CopyLight)({
  textDecorationLine: 'underline',
  cursor: 'pointer',
});
